import React from 'react';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { ILowesStormDoorListing } from '../../../../entities-generated/models/lowes-storm-door/lowes-storm-door-listing';
import { ProductImportStatus } from '../../../../entities-generated/common/product-import-status';

interface ILowesStormDoorListItemProps {
  listing: ILowesStormDoorListing;
  onClick: (listing: ILowesStormDoorListing) => void;
}

export const LowesStormDoorListItem: React.FunctionComponent<ILowesStormDoorListItemProps> = (props) => {
  const { listing } = props;

  return (
    <BwjListing
      heading={listing.name}
      secondaryLine={ProductImportStatus[listing.importStatus]}
      data={listing}
      onClick={props.onClick}
    />
  );
};
